import * as React from 'react'
import { Box } from "@mui/material"
import {TooltipSeeker} from "@ui-seeker/core"
import {formatNumber, isEmpty} from "@ui-seeker/utils"


export default function graphColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value) => {
				return <Box sx={{ display: 'flex', height: '15px', width: '90%', borderRadius: '15px', overflow: 'hidden' }}>
					{Object.keys(value).map((key) => {
						return <TooltipSeeker key={key} title={`${key}: ${formatNumber(value[key].share, { decimals: 0 })}% (${value[key].total})`}>
							<Box sx={{ width: `${value[key].share}%`, backgroundColor: getSegmentColor(key), height: '100%' }} />
						</TooltipSeeker>
					})}
				</Box>
			}
		}
	}
}

const getSegmentColor = (key) => {
	const colorMap = {
		'IA': '#26aaff',
		'QA': '#44e0a8',
		'Normalizer': '#ffb74d',
		'Validated': '#44e0a8',
		'NonValidated': '#ff4953',
		'Mapped': '#44e0a8',
		'NonMapped': '#ff4953',
		'Skip': '#ffb74d'
	}
  return colorMap[key] || '#cccccc'
}



